// extracted by mini-css-extract-plugin
module.exports = {"container":"Caz7Fc-K","button":"_16vhCDZw","disabled":"_199sGH-0","paginationText":"_2FfEAUH5"};